import script from "./ControleMovimentosRepository.vue?vue&type=script&lang=js"
export * from "./ControleMovimentosRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__